import React from 'react'
import '../Styles/TeenCampPage1.scss';

function TeenCampPage1() {
   return (
      <div className="teenCampPage1Content">
         <div className="teenCampPage1Container">
            <div className="teenCampPage1Title">
               Youth Camp
            </div>
            <div div className="teenCampPage1Description">
               Highschoolers can bond over intense sports competitions <br></br>
               and be challenged  by the dynamic preaching from God's Word.<br></br>
               Come and experience a week of youth camp for yourself!
            </div>
            <div className="teenCampPage1WeeksContainer">
               <div className="teenCampPage1Weeks">
                  <div className="teenCampWeek1">
                     <div className="week1Title">
                        Week One
                     </div>
                     <div className="week1Content">
                        June 12 - June 16, 2023
                     </div>
                  </div>

                  <div className="vl"></div>

                  <div className="teenCampWeek2">
                     <div className="week2Title">
                        Week Two
                     </div>
                     <div className="week2Content">
                        June 26 - June 30, 2023
                     </div>
                  </div>

                  <div className="vl"></div>

                  <div className="teenCampWeek3">
                     <div className="week3Title">
                        Week Three
                     </div>
                     <div className="week3Content">
                        July 10 - July 14th 2023
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}
export default TeenCampPage1;